import {AccountStore} from "../../../account/store/AccountStore";
import {AccountBriefRecords} from "../../../account/types/AccountBriefRecord";
import {Branding} from "../../../types/Branding";
import {UserConfig} from "../../../types/UserConfig";
import {VirtualPageView, VIRTUAL_PAGE_VIEWS} from "../../../types/VirtualPageViews";
import {PortfolioType} from "../../../portfolio/models/Portfolio";
import {pushDataLayer} from "../../../analytics/util/pushDataLayer";
import {initGTM} from "../../../analytics/util/analyticUtil";

export class OpenTraderConversionEventService {

    public static id = "openTraderConversionEventService";

    /** @ngInject */
    public constructor(private userConfig: UserConfig, private readonly accountStore: AccountStore) {}

    public checkForDemoOnlyAccount() {
        this.accountStore
        .userAccounts
        .first()
        .filter((accounts) => this.hasNoBrokerAccount(accounts))
        .filter(() => this.userConfig?.client?.onBoarded != null)
        .subscribe(() => this.sendDemoPageView());
    }

    private hasNoBrokerAccount(accounts: AccountBriefRecords): boolean {
        return accounts.every((a) => a.portfolioType !== PortfolioType.BROKER);
    }

    private sendDemoPageView() {
        this.sendVirtualPageView(VIRTUAL_PAGE_VIEWS.ReturningDemo);
    }

    public sendConversionEvent() {
        if (this.userConfig.branding === Branding.OPEN_TRADER) {
            initGTM("GTM-PWHJQC7");
        }
    }

    public sendVirtualPageView(virtualPageView: VirtualPageView) {
        if (this.userConfig.branding === Branding.OPEN_TRADER) {
            const { url, title, timestamp } = virtualPageView;
            if (timestamp !== undefined) {
                pushDataLayer("VirtualPageView", {virtualPageURL: url, virtualPageTitle: title, timestamp});
            } else {
                pushDataLayer("VirtualPageView", {virtualPageURL: url, virtualPageTitle: title});
            }
        }
    }

    public sendUserIDView() {
        if (this.userConfig.branding === Branding.OPEN_TRADER) {
            const userId = this.userConfig.uid;
            if (userId !== undefined || userId !== "") {
                pushDataLayer("login", {userId});
            }
        }
    }
}
